import React, { useContext, useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router";
import { SzakokContext } from "../context/SzakokContext";
import { UserContext } from "../context/UserContext";
import { LanguageProvider, useLanguage } from "../context/LanguageContext";
import SzakokFinder from '../apis/SzakokFinder';
import Modal from 'react-modal';
import Dropzone from 'react-dropzone';
// import "./SzakjelentesekDetailsPage.css";
import "../components/szakjelentesCreate/SzakjelentesCreate.css";
import "../components/szakjelentesCreate/MediaManager.css";
import '../components/szakjelentesCreate/DialogModals.css';
import '../components/szakjelentesCreate/OpinionSection.css';
import '../components/szakjelentesCreate/SzakjelentesLezaras.css';
import SideTile from "../components/SideTile";
import PDFViewer from '../components/PDFViewer';
import AttachFileIcon from '@mui/icons-material/AttachFile';
// import "../components/Ujszak.css";
import { SZAKJELENTESEK_DETAILS_TRANSLATIONS } from "./SzakjelentesekDetailsPageTranslations";

Modal.setAppElement('#root');

const SzakjelentesekDetailsPageContent = () => {
    const { szakId } = useParams();
    const { selectedSzak, setSelectedSzak } = useContext(SzakokContext);
    const { userData } = useContext(UserContext);
    const { language, loading } = useLanguage();
    const navigate = useNavigate();

    const t = loading ? SZAKJELENTESEK_DETAILS_TRANSLATIONS.hu : (SZAKJELENTESEK_DETAILS_TRANSLATIONS[language] || SZAKJELENTESEK_DETAILS_TRANSLATIONS.hu);

    const [editableSzak, setEditableSzak] = useState(null);
    const [attachedPdfs, setAttachedPdfs] = useState([]);
    const [szakfelelosNev, setSzakfelelosNev] = useState("");
    const [statusData, setStatusData] = useState({});
    const [isFinalizeButtonDisabled, setIsFinalizeButtonDisabled] = useState(true);
    const [uploadedOpinions, setUploadedOpinions] = useState([]);
    const [isSideTileVisible, setIsSideTileVisible] = useState(true);
    const [mellekletFiles, setMellekletFiles] = useState([]);
    const [showCustomAlert, setShowCustomAlert] = useState(false);
    const [isPageInteractionDisabled, setIsPageInteractionDisabled] = useState(false);
    const [alertType, setAlertType] = useState(''); // 'finalize' or 'opinion'
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [isFinalizing, setIsFinalizing] = useState(false);
    const [finalizeError, setFinalizeError] = useState('');
    const finalizeRequestInProgress = useRef(false);
    const pdfGenerationPromise = useRef(null);

    // Effect to disable/enable page interaction when modal is open
    useEffect(() => {
        setIsPageInteractionDisabled(showCustomAlert);
        if (showCustomAlert) {
            // Add a class to the body instead of inline styles
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }

        // Cleanup function
        return () => {
            document.body.classList.remove('modal-open');
        };
    }, [showCustomAlert]);

    const [opinions, setOpinions] = useState([]); // Vélemények listája
    const [newOpinion, setNewOpinion] = useState(""); // Új vélemény beviteli mező állapota

    const sideTileRef = useRef(null);

    const fetchAttachedPdfs = async () => {
        try {
            const pdfResponse = await SzakokFinder.get(`/api/pdf/szakok/${szakId}/pdfs`);
            setAttachedPdfs(pdfResponse.data.data);
        } catch (err) {
            console.log("API Error (attached PDFs):", err);
        }
    };

    const fetchMellekletFiles = async () => {
        try {
            if (statusData["Mellékletek"] === 3) {
                const token = localStorage.getItem('token');
                const cvRes = await fetch(`${process.env.REACT_APP_API_BASE_URL}/szakok/${szakId}/pdfs/cv`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const cegekRes = await fetch(`${process.env.REACT_APP_API_BASE_URL}/szakok/${szakId}/pdfs/cegek`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const cvFiles = (await cvRes.json()).data || [];
                const cegekFiles = (await cegekRes.json()).data || [];
                setMellekletFiles([...cvFiles, ...cegekFiles]);
            } else {
                setMellekletFiles([]);
            }
        } catch (error) {
            console.error("Error fetching Mellékletek files:", error);
        }
    };

    const isLocked = editableSzak?.status === 3;

    useEffect(() => {
        const fetchData = async () => {
            try {
                console.log("Fetching szak adat:", szakId);
                const response = await SzakokFinder.get(`/szakok/${szakId}`);
                const szakData = response.data.data;
                console.log("Fetched szakData:", szakData);

                if (szakData) {
                    setSelectedSzak(szakData);
                    setEditableSzak(szakData);

                    // Szakfelelős adat lekérése
                    const szakfelelosResponse = await SzakokFinder.get(`/szakfelelosok/szakkod/${szakData.szak_kod}`);
                    if (szakfelelosResponse.data.status === "success" && szakfelelosResponse.data.data) {
                        setSzakfelelosNev(szakfelelosResponse.data.data.szakfelelos_neve);
                    }

                    // Vélemények lekérése
                    const opinionsResponse = await SzakokFinder.get(`/velemenyek/${szakId}`);
                    console.log("Opinions fetched:", opinionsResponse.data.data);

                    // Ellenőrizzük a felhasználó Neptun-kódját és nevezzük át a username-t helyesen
                    const updatedOpinions = opinionsResponse.data.data.map(opinion => ({
                        ...opinion,
                        username: opinion.username || (opinion.neptun === userData.neptun ? userData.name : "Ismeretlen felhasználó")
                    }));

                    // **Ellenőrizzük, hogy nincs-e duplikáció a fetch után**
                    const uniqueOpinions = updatedOpinions.filter(
                        (opinion, index, self) =>
                            index === self.findIndex((op) => op.id === opinion.id)
                    );

                    setOpinions(uniqueOpinions);
                }

                // PDF-ek lekérése
                await fetchAttachedPdfs();

            } catch (err) {
                console.error("API Error:", err);
            }
        };

        fetchData();
    }, [szakId, setSelectedSzak, userData]);




    useEffect(() => {
        const fetchStatusData = async () => {
            try {
                const response = await SzakokFinder.get(`/szakjelentes_letrehozas/${szakId}/status`);
                console.log("=== DEBUG: Status Check ===");
                console.log("Full status data response:", response.data.data);
                const rawStatusData = response.data.data;

                // Use statusKeys which match the database keys exactly
                const requiredStatuses = SZAKJELENTESEK_DETAILS_TRANSLATIONS.hu.statusKeys;

                console.log("Required statuses to check (count: " + requiredStatuses.length + "):", requiredStatuses);
                
                // Check each status individually and track which ones are NOT 3
                const failedStatuses = [];
                const passedStatuses = [];
                
                requiredStatuses.forEach((status) => {
                    const statusValue = rawStatusData[status];
                    if (statusValue === 3) {
                        passedStatuses.push(status);
                        console.log(`✅ "${status}": ${statusValue}`);
                    } else {
                        failedStatuses.push(status);
                        console.warn(`❌ "${status}": ${statusValue} (NOT 3!)`);
                    }
                });

                console.log("\n=== SUMMARY ===");
                console.log("Passed (status = 3):", passedStatuses.length, "sections");
                console.log("Failed (status != 3):", failedStatuses.length, "sections");
                if (failedStatuses.length > 0) {
                    console.warn("Sections blocking finalization:", failedStatuses);
                }

                const allStatusesAreThree = requiredStatuses.every(
                    (status) => rawStatusData[status] === 3
                );

                console.log("All required statuses are 3:", allStatusesAreThree);
                console.log("Setting isFinalizeButtonDisabled to:", !allStatusesAreThree);
                console.log("editableSzak.status:", editableSzak?.status);
                console.log("Button will be disabled because:", 
                    !allStatusesAreThree ? "Not all sections complete" : 
                    editableSzak?.status >= 2 ? "Status >= 2" : 
                    "Unknown reason");
                console.log("===================\n");
                
                setIsFinalizeButtonDisabled(!allStatusesAreThree);
                setStatusData(rawStatusData);
            } catch (error) {
                console.error("Error fetching status data:", error);
            }
        };

        fetchStatusData();
    }, [szakId, editableSzak?.status]);

    const handleFinalize = () => {
        if (isFinalizeButtonDisabled) {
            console.log("Finalize button is disabled, action prevented.");
            return;
        }
        setFinalizeError('');
        // Show confirmation modal for the new single button action
        setShowConfirmationModal(true);
    };

    const handleGeneratePDFBackground = async () => {
        try {
            const token = localStorage.getItem('access_token');
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/api/pdf/generate-pdf/${szakId}`,
                {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (!response.ok) {
                throw new Error('Failed to generate PDF');
            }

            // A generate-pdf már lemezre és adatbázisba menti a fájlt.
            // Az újraküldés azonos fájlnévnél törölhette a frissen generált PDF-et.
            await response.json();
        } catch (err) {
            console.error('Failed to generate and save PDF in background', err);
        }
    };

    const handleConfirmFinalize = async () => {
        if (finalizeRequestInProgress.current) return;
        finalizeRequestInProgress.current = true;
        setIsFinalizing(true);
        setFinalizeError('');
        try {
            const updatedSzak = { ...editableSzak, filling_status: 3, status: 2 };
            console.log("Finalizing szak with data:", updatedSzak);
            await SzakokFinder.put(`/szakok/${szakId}`, updatedSzak);

            setSelectedSzak(updatedSzak);
            setEditableSzak(updatedSzak);
            setIsFinalizeButtonDisabled(true); // 🔹 GOMB INAKTÍVVÁ TÉTELE
            setShowConfirmationModal(false);
            setAlertType('finalize');
            setShowCustomAlert(true);
            // A PDF generálása ne tartsa nyitva a megerősítő ablakot.
            pdfGenerationPromise.current = handleGeneratePDFBackground();
        } catch (err) {
            console.error("Error finalizingszak:", err);
            setFinalizeError(err.response?.data?.error || 'Nem sikerült lezárni a szakjelentést. Próbálja újra.');
        } finally {
            finalizeRequestInProgress.current = false;
            setIsFinalizing(false);
        }
    };

    const handleCancelFinalize = () => {
        if (finalizeRequestInProgress.current) return;
        setShowConfirmationModal(false);
    };

    const handleCustomAlertOk = async () => {
        const shouldReloadAfterFinalize = alertType === 'finalize';
        setShowCustomAlert(false);
        setIsPageInteractionDisabled(false);
        setAlertType('');

        if (shouldReloadAfterFinalize) {
            await pdfGenerationPromise.current;
            window.location.reload();
        }
    };

    const handleOpinionSubmit = async () => {
        if (newOpinion.trim() === "") return; // Üres véleményeket ne küldjük be

        try {
            console.log("Submitting new opinion:", newOpinion);
            const token = localStorage.getItem("token");

            const username = userData?.name || szakfelelosNev; // Ha nincs userData.name, akkor a szakfelelős neve

            const response = await SzakokFinder.post(
                `/velemenyek/${szakId}`,
                { content: newOpinion, username }, // Mindig elküldjük a nevet!
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            console.log("New opinion response:", response.data.data);

            setOpinions((prevOpinions) => {
                // **Ellenőrizzük, hogy már szerepel-e az új vélemény**
                if (prevOpinions.some(op => op.id === response.data.data.id)) {
                    return prevOpinions;
                }
                return [...prevOpinions, response.data.data]; // Ha nincs benne, hozzáadjuk
            });

            setNewOpinion("");
        } catch (err) {
            console.error("Nem sikerült menteni a véleményt:", err);
        }
    };

    const handleOpinionDelete = async (opinionId) => {
        try {
            console.log("Deleting opinion with id:", opinionId);
            await SzakokFinder.delete(`/velemenyek/${opinionId}`);
            setOpinions(opinions.filter((opinion) => opinion.id !== opinionId));
        } catch (err) {
            console.error("Nem sikerült törölni a véleményt:", err);
        }
    };

    const handleViewPDF = (filename) => {
        const url = `${process.env.REACT_APP_API_BASE_URL}/uploads/${filename}`;
        window.open(url, '_blank', 'noopener noreferrer');
    };

    const handleViewOpinion = (filename) => {
        const url = `${process.env.REACT_APP_API_BASE_URL}/uploads/${filename}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    // When continuing to fill the report, navigate to the first section (Képzés célja)
    const handleBack = () => navigate(`/szakjelentes_letrehozas/${szakId}/kepzes-celja`);
    const handleUp = () => navigate('/szakjelentesek');

    const handleOpinionUpload = async (acceptedFiles) => {
        const formData = new FormData();
        formData.append("file", acceptedFiles[0]);

        try {
            console.log("Uploading opinion file:", acceptedFiles[0]);
            // Vélemény feltöltés
            const response = await SzakokFinder.post(`/velemenyek/${szakId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });
            console.log("Opinion file upload response:", response.data);
            setUploadedOpinions([...uploadedOpinions, response.data]);

            // Szak állapot frissítése (status = 3)
            await SzakokFinder.put(`/szakok/${szakId}`, {
                name: editableSzak.name,
                felev: editableSzak.felev,
                status: 3,
                modosito_neve: editableSzak.modosito_neve,
                filling_status: editableSzak.filling_status
            });

            setSelectedSzak((prev) => ({ ...prev, status: 3 }));
        } catch (error) {
            console.error("Vélemény feltöltése sikertelen:", error);
        }
    };

    // Ha még tölt, mutassuk a "Loading..." feliratot
    if (!editableSzak) {
        return <div>Loading...</div>;
    }

    // Super user ellenőrzése: csak akkor láthatja, ha status 3 vagy 4 vagy 5
    if (userData?.role === 'admin' && ![2, 3].includes(editableSzak.status)) {
        console.log("Super user hozzáférés megtagadva, szak status:", editableSzak.status);
        navigate("/szakjelentesek");
        return null;
    }

    const isFillingStatusValid = editableSzak.filling_status !== 3;
    const isPdfAvailable = attachedPdfs.length > 0;

    const handleStatusUpdate = async () => {
        try {
            if (editableSzak.status !== 3 && editableSzak.status !== 4) {
                return;
            }

            if (userData?.role === 'szakfelelos') {
                console.log("Nincs jogosultság a végleges lezáráshoz.");
                alert("Nincs jogosultság a végleges lezáráshoz.");
                return;
            }

            const newStatus = 5; // Teljes szakjelentés lezárása

            await SzakokFinder.put(`/szakok/${szakId}`, { ...editableSzak, status: newStatus });

            setSelectedSzak((prev) => ({ ...prev, status: newStatus }));
            setEditableSzak((prev) => ({ ...prev, status: newStatus }));

            alert(`Sikeresen frissítve: új státusz ${newStatus}`);
        } catch (err) {
            console.error("Hiba történt a státusz frissítésekor:", err);
        }
    };

    const handleDecreaseStatus = async () => {
        if (!editableSzak) return;

        let newStatus = editableSzak.status - 1;
        if (newStatus < 1) {
            alert("A státusz nem lehet 0 vagy annál kisebb!");
            return;
        }

        try {
            console.log(`⚠️ Teszt: Státusz csökkentése ${editableSzak.status} → ${newStatus}`);
            await SzakokFinder.put(`/szakok/${szakId}`, { ...editableSzak, status: newStatus });

            setSelectedSzak((prev) => ({ ...prev, status: newStatus }));
            setEditableSzak((prev) => ({ ...prev, status: newStatus }));

            alert(`Sikeresen csökkentett státusz: ${newStatus}`);
        } catch (err) {
            console.error("Hiba történt a státusz csökkentésekor:", err);
        }
    };


    return (
        <div className="szakjelentes-create-wrapper">
        <div className="szakjelentes-details uj-szak-page">
            {/* SideTile csak akkor jelenjen meg, ha NEM super user */}
            {userData?.role === 'szakfelelos' && (
                <SideTile
                    ref={sideTileRef}
                    id={szakId}
                    texts={t.sidebar}
                    isVisible={isSideTileVisible}
                />
            )}

            <div className="details-container uj-szak-container">
                <div className="button-container">
                    {/* Előző szakasz gomb csak NEM super usernek */}
                    {userData?.role === 'szakfelelos' && (
                        <button onClick={handleBack} className="szak-button">
                            {t.previousSection}
                        </button>
                    )}
                    {/* Vissza a szakjelentés listába gomb mindenkinek látható */}
                    <div className="button-container">
                        <button onClick={handleUp} className="szak-button">
                            {t.backToList}
                        </button>
                    </div>
                </div>

                <h1>
                    {t.pageTitle}
                    {userData?.role === 'admin' && editableSzak?.name && (
                        <span className="szak-nev">  {editableSzak.name}</span>
                    )}
                </h1>

                {/* Status alapján megjelenő gombok */}
                {userData?.role === 'szakfelelos' && (
                    <div className="szak-button-container-custom">
                        <button
                            onClick={handleFinalize}
                            className="szak-button-custom finalize-button"
                            disabled={isFinalizeButtonDisabled || editableSzak?.status >= 2}
                        >
                            {t.finalizeButton}
                        </button>
                    </div>
                )}


                {/* TESZT GOMB: STÁTUSZ CSÖKKENTÉSE 
    <div className="test-status-button-container">
        <button onClick={handleDecreaseStatus} className="test-status-button">
            ⚠️ Teszt: Státusz Csökkentése
        </button>
    </div>
    */}


                <div className="attached-pdfs">
                    <h3>{t.attachedPdfs}</h3>
                    <ul>
                        {attachedPdfs.map((pdf) => (
                            <li key={pdf.id} className="pdf-item" onClick={() => handleViewPDF(pdf.filename)}>
                                <AttachFileIcon className="pdf-icon" />
                                <span className="pdf-filename">{pdf.filename}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Vélemények szekció */}
                {isPdfAvailable && (
                    <div className="opinion-section">
                        <h3>{t.opinions}</h3>

                        {/* Vélemény beviteli mező */}
                        <textarea
                            className="opinion-input"
                            placeholder={t.opinionPlaceholder}
                            value={newOpinion}
                            onChange={(e) => setNewOpinion(e.target.value)}
                            disabled={isLocked}
                        />

                        {/* Küldés gomb */}
                        <button onClick={handleOpinionSubmit} className="opinion-submit-button" disabled={isLocked}>
                            {t.addOpinion}
                        </button>

                        {/* Megjelenített vélemények */}
                        <ul className="opinions-list">
                            {opinions.map((opinion) => (
                                <li key={`${opinion.id}-${opinion.created_at}`} className="opinion-item">
                                    <div className="opinion-content">
                                        <strong>{opinion.username}</strong>
                                        <span className="opinion-date">({new Date(opinion.created_at).toLocaleString()})</span>
                                        <p>{opinion.content}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>

            {/* Confirmation Modal for Finalization */}
            <Modal
                portalClassName="szakjelentes-create-wrapper"
                isOpen={showConfirmationModal}
                onRequestClose={handleCancelFinalize}
                contentLabel="Szakjelentés Lezárásának Megerősítése"
                className="confirmation-modal"
                overlayClassName="confirmation-overlay"
                shouldCloseOnOverlayClick={false}
            >
                <div className="confirmation-modal-content">
                    <div className="confirmation-modal-message">
                        {t.confirmMessage}
                    </div>
                    {finalizeError && <p className="confirmation-modal-error" role="alert">{finalizeError}</p>}
                    <div className="confirmation-modal-buttons">
                        <button
                            type="button"
                            onClick={handleCancelFinalize}
                            className="confirmation-button-cancel"
                            disabled={isFinalizing}
                        >
                            {t.confirmCancel}
                        </button> 
                        <button
                            type="button"
                            onClick={handleConfirmFinalize}
                            className="confirmation-button-confirm"
                            disabled={isFinalizing}
                        >
                            {t.confirmYes}
                        </button>
                    </div>
                </div>
            </Modal>

            {/* Custom Alert Modal */}
            <Modal
                portalClassName="szakjelentes-create-wrapper"
                isOpen={showCustomAlert}
                onRequestClose={() => {
                    setShowCustomAlert(false);
                    setIsPageInteractionDisabled(false);
                }}
                contentLabel="Szakjelentés Lezárva"
                className="custom-alert-modal"
                overlayClassName="custom-alert-overlay"
                shouldCloseOnOverlayClick={false}
            >
                <div className="custom-alert-content">
                    <div className="custom-alert-message">
                        {alertType === 'opinion' ? t.alertOpinion : t.alertFinalized}
                    </div>
                    <button
                        onClick={handleCustomAlertOk}
                        className="custom-alert-button"
                    >
                        {t.ok}
                    </button>
                </div>
            </Modal>
        </div>
        </div>
    );
};

// Wrapper component to fetch szakKod and provide LanguageContext
const SzakjelentesekDetailsPage = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);

    useEffect(() => {
        const fetchSzak = async () => {
            try {
                const response = await SzakokFinder.get(`/szakok/${szakId}`);
                const szakData = response.data.data;
                if (szakData && szakData.szak_kod) {
                    setSzakKod(szakData.szak_kod);
                }
            } catch (err) {
                console.error("Error fetching szak for szakKod:", err);
            }
        };

        fetchSzak();
    }, [szakId]);

    if (!szakKod) {
        return <div>Loading...</div>;
    }

    return (
        <LanguageProvider szakKod={szakKod}>
            <SzakjelentesekDetailsPageContent />
        </LanguageProvider>
    );
};

export default SzakjelentesekDetailsPage;
